import { Col, Row } from 'antd';

import SpinC from 'src/components/Layout/Spin';
import { useTermsPolicy } from 'src/hooks/Policy';

import classes from './terms.module.css';
import cn from 'src/utils/cn';

const TermsContainer = () => {
	const { data, isLoading } = useTermsPolicy();

	const content = data?.data?.record?.terms_content || null;

	if (isLoading) return <SpinC />;

	if (!content) return null;

	return (
		<div className={`container ${classes['wrap-container']}`}>
			<div className={cn(classes['wrap-content'], 'relative')}>
				<h3 className="font-bold text-lg absolute top-0 right-5 md:top-5 md:right-5"> {`Versi ${data?.data.record.version}.0`}</h3>
				<Row gutter={0}>
					<Col sm={{ span: 24 }} xs={{ span: 24 }}>
						<div
							className={classes['paragraph-content']}
							dangerouslySetInnerHTML={{
								__html: content,
							}}
						/>
					</Col>
				</Row>
			</div>
		</div>
	);
};

export default TermsContainer;
